import React from 'react'
import { useSelector } from 'react-redux'
import { getValueOption, valueOption } from '../../../store/selectors/selectors'
import { dependencySettingT, IComponent } from '../../../utils/type/dynamic-rendering.interfaces'
import { inputComponentsAdditionalProperties } from '../LineParam/LineParams'
//@ts-ignore
import s from './GroupSettingBase.module.scss'



type GroupSettingBaseT = {
    children: any
    dependencySettings?: dependencySettingT[]
    embeddedView: IComponent[]
    additionalProperties?: inputComponentsAdditionalProperties
    id: string
    isVisible: boolean
    [key: string]: unknown;
}

export const GroupSettingBase = ({ ...props }: GroupSettingBaseT) => {

    let { children, isVisible, dependencySettings, additionalProperties } = props;
    let isVisibleDependency: dependencySettingT | any;

    if (dependencySettings && dependencySettings.length > 0) {
        isVisibleDependency = dependencySettings.filter(dependency => dependency['dependencyType'] === 'isVisible')[0]
    }
    let { selectValue }: valueOption = useSelector(state => getValueOption({ idOptions: !!isVisibleDependency ? isVisibleDependency['idParams'] : 'emptyParams' })(state));
    if (!!isVisibleDependency) {

        isVisible = selectValue === isVisibleDependency['isValue'];
    }



    let style: any = {};
    if (additionalProperties && additionalProperties['groupGap']) {
        style = {
            ...style,
            display: 'grid',
            gap: '15px',
        }
    }
    if (additionalProperties && additionalProperties['gap']) {
        style = {
            ...style,
            gap: additionalProperties['gap'],
        }
    }
    if (additionalProperties && additionalProperties['backgroundColor']) {
        style = {
            ...style,
            backgroundColor: additionalProperties['backgroundColor'],
        }
    }
    if (additionalProperties && additionalProperties['padding']) {
        style = {
            ...style,
            padding: additionalProperties['padding'],
        }
    }
    if (additionalProperties && additionalProperties['margin']) {
        style = {
            ...style,
            margin: additionalProperties['margin'],
        }
    }

    return (
        <>
            {isVisible && (<div className={s.wrap} style={style} >
                {children}
            </div>)}
        </>
    )
}
